<template>
  <div>
    <nav-bar :title="`Rate ${childName}`"></nav-bar>
    <rate-skeleton v-if="loading"></rate-skeleton>
    <div v-else class="atm-desktop-max-width mobile d-flex gap-3 flex-column py-4">
      <h4 class="mb-0 text-main font-weight-600 w-100">
        Please provide your rating.
      </h4>
      <div>
        <b-alert
          :show="true"
          variant="primary"
        >
          <span v-if="Object.keys(weekAnswers).length">
            {{ childName }} has already been rated.
          </span>
          <span v-else>
            {{ childName }} has not been rated.
          </span>
      </b-alert>
      </div>
      <div
        v-for="(rate, id) in questionsRate"
        :key="id"
        class="d-flex gap-3 flex-wrap justify-content-between b-1 py-3 mx-1 align-items-center"
      >
        <label class="font-weight-600 w-100">
          <span class="text-capitalize"> {{ childName }} </span>
          's {{ rate.question }}
        </label>
        <div class="position-relative d-flex flex-column align-items-center w-100">
          <div class="steppers-container position-absolute d-flex justify-content-between align-items-center w-100">
            <div v-for="stepper in 5" :key="stepper" class="rounded-pill"></div>
          </div>
          <input
            :id="`range ${rate.id}`"
            v-model="rate.answer"
            type="range"
            min="1"
            max="5"
            class="position-relative w-100"
          />
        </div>
        <div class="d-flex justify-content-between w-100">
          <small>Problematic</small>
          <small>Excellent </small>
        </div>
      </div>
      <button class="atm-button bg-main mx-auto w-50" @click="sendData">
        Submit
      </button>
    </div>
  </div>
</template>
<script>
import { NavBar } from '@/common/components';
import { useSessionStore } from '@/common';
import { getQuestionsRate, setAnswersRate, getWeekAnswersRate } from '../services';
import rateSkeleton from '../components/skeletons/RateSkeleton.vue';
import notificationToastMixin from '@/Mixins/notificationToast.mixin';

export default {
  components: {
    NavBar,
    rateSkeleton,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      loading: false,
      questionsRate: {},
      weekAnswers: {},
      sessionStore,
    };
  },
  mixins: [notificationToastMixin],
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    childName() {
      return this.sessionStore.childName;
    },
    childId() {
      return this.sessionStore.childSelectedId;
    },
  },
  async mounted() {
    this.getQuestions();
  },
  methods: {
    async sendData(){
      const dataAnswersRate = this.questionsRate.map((question) => 
        ({
          question: question.id,
          answer: question.answer
        })
      )
      const dataRate = {
        answers: dataAnswersRate,
        child: this.childId
      }
      try {
        await setAnswersRate(dataRate);
        this.getQuestions();
        this.notificationToast({
          message: 'Answers saved successfully',
          variant: 'primary',
          title: 'Success',
        });
      } catch (error) {
        console.log('rate', error);
      }
    },
    async getQuestions(){
      this.loading = true;
      try {
        await this.getWeekAnswers();
        this.questionsRate = await getQuestionsRate();
        this.questionsRate = this.questionsRate.map((question) => 
          this.weekAnswers[question.id] ? ({...question, answer: this.weekAnswers[question.id]}) : ({...question, answer: "3"})
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async getWeekAnswers(){
      try {
        this.weekAnswers = await getWeekAnswersRate(this.childId);
        this.weekAnswers = Object.fromEntries(this.weekAnswers.answers.map((weekAnswer) => [
          weekAnswer.rate_question.id,
          weekAnswer.answer.toString()
        ]));
      } catch (error) {
        console.error(error);
      } 
      
    },
  },
}
</script>
<style lang="scss">
.steppers-container {
  top: 0;
  bottom: 0;
  & > div {
    background-color: #f1f1f1;
    width: 25px;
    height: 25px;
  }
}
</style>